import React from 'react';
import { Box, Button, Heading, Image, Text, VStack } from '@chakra-ui/react';
import { formatCilPoints } from '../../utils/cilPoints';
import { getRewardImageUrl } from '../../utils/rewardMediaUrl';

/**
 * Card premio catalogo: immagine verticale, nome, disponibilità, punti e (opz.) riscatta.
 */
const RewardCatalogCard = ({ reward, onRedeem, readOnly = false }) => {
  const img = getRewardImageUrl(reward.image);
  const maxQty = reward.stockQuantity || 0;
  const points = Number(reward.pointsCost) || 0;
  const outOfStock = maxQty < 1;

  return (
    <Box
      bg="white"
      borderRadius="xl"
      overflow="hidden"
      boxShadow="sm"
      border="1px solid"
      borderColor="gray.100"
      display="flex"
      flexDirection="column"
      h="full"
    >
      <Box position="relative" w="full" pt="133.33%" bg="brand.50">
        {img ? (
          <Image
            src={img}
            alt={reward.name}
            position="absolute"
            inset={0}
            w="full"
            h="full"
            objectFit="cover"
          />
        ) : null}
      </Box>

      <VStack align="stretch" spacing={2} p={4} flex={1}>
        <Heading
          as="h3"
          size="sm"
          noOfLines={2}
          lineHeight="short"
          color="gray.800"
        >
          {reward.name}
        </Heading>
        <Text fontSize="sm" color="gray.600">
          Disponibili: {maxQty}
        </Text>
        <Text fontWeight="bold" color="purple.600" fontSize="md" mt="auto">
          {formatCilPoints(points)}
        </Text>
        {!readOnly && (
          <Button
            colorScheme="purple"
            size="sm"
            w="full"
            isDisabled={outOfStock}
            onClick={() => onRedeem?.(reward)}
          >
            {outOfStock ? 'Esaurito' : 'Riscatta'}
          </Button>
        )}
      </VStack>
    </Box>
  );
};

export default RewardCatalogCard;
